module.exports = __webpack_public_path__ + "img/19.6b2da0c2.png";